import BreadCumb from '../components/doglists/BreadCumb';
import Faq from '../components/Faq'
import BreedServices from '../components/BreedServices'
import NewsLetter from '../components/NewsLetter'
import ShopArea from '../components/ourshop/ShopArea';
import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';


function DogList() {

useEffect(() => {
  window.scrollTo({ top: 0, behavior: "smooth" });
}, []);

	return (

		<main>
			 <Helmet>
        <title>Chiens - Animalia</title>
        <meta name="description" content="Découvrez notre sélection de nos produits pour chiens chez Animalia." />
      </Helmet>

			<BreadCumb />
			{/* <DogsList/> */}
			<ShopArea />
			{/* <AdoptionShop/> */}
			<Faq afterElment="faq-area-two" />
			<BreedServices />
			<NewsLetter />
		</main>
	)
}

export default DogList;
